import logo from "@assets/stafi_logo.svg";
import "./index.scss";

export default function Index() {
  return (
    <div className="header">
      <img src={logo} />
    </div>
  );
}
